import React, { ReactNode } from 'react';
import { useFormik, FormikHelpers } from 'formik';
import { BillingEntryProps } from '../helpers/models/Models';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { extractUserID } from '../helpers/extractData';
import { NowNepaliMonthName, NowNepaliYearName } from '../constants/DateFormat';

export interface BillingEntryContextType {
    ResetForm: () => Promise<void>;
    initialValues: BillingEntryProps;
    values: BillingEntryProps;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
    handleChange: (e: React.ChangeEvent<any>) => void;
    handleSelectBox: (name: string, value: any) => void;
    errors: { [key: string]: string | undefined };
    touched: { [key: string]: boolean };
    handleBlur: (e: React.FocusEvent<any>) => void;
    handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
}

export const BillingContext = React.createContext<BillingEntryContextType | undefined>(undefined);

interface BillingEntryContextTypeProps {
    children: ReactNode;
}
const BillinEntryContext: React.FC<BillingEntryContextTypeProps> = ({ children }) => {
    const userId = extractUserID();
    const currentYear = NowNepaliYearName();
    const currentMonth = NowNepaliMonthName();
    const deposit_month = currentMonth ? String(parseInt(currentMonth)) : "";
    const { current_fiscal_year_list } = useSelector((state: RootState) => state.software);
    
    const initialValues: BillingEntryProps = {
        date_en: new Date().toISOString().split('T')[0] || "",
        date_ne: "",
        clr_date_n: "",
        marga_tole_name: "",
        clr_date_e: "",
        fiscal_year_name: current_fiscal_year_list?.fiscal_year?.fiscal_year_name || "",
        fiscal_from_date: current_fiscal_year_list?.fiscal_year?.from_date_n || "",
        user_no: parseInt(userId ||"1"),
        total_right_top_amt: 0,
        receive_amt: 0,
        adjust_advance: false,
        right_total_amt: 0,
        tot_particular_amt: 0,
        total_every_month_amt: 0,
        advance_amt: 0,
        total_mahasul_amt: 0,
        fine_amt: 0,
        chhut_amt: 0,
        refund_advance_amt: 0,
        payment_mode: "5",
        bank_sglsn: "",
        glid: "",
        cash_sglsn: "",
        deposit_year: currentYear||"",
        deposit_month: deposit_month ||"",
        member_sn: 0,
        mem_name: "",
        total_pay_amt: 0,
        emi_amt: 0,
        emi_amt_due: "",
        emi_paid: "",
        billing_no: 0,
        check_ad_advace: false,
    };
   
    const formik = useFormik<BillingEntryProps>({
        initialValues,
        enableReinitialize: true,
        onSubmit: async (values, action: FormikHelpers<BillingEntryProps>) => {
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
                const value = (values as Record<string, any>)[key];
                if (value !== undefined && value !== null && value !== "") {
                    formData.append(key, value);
                }
            });
        },
    });

    const { values, handleChange, errors, touched, handleBlur, handleSubmit, setFieldValue } = formik;
    const ResetForm = async () => {
        formik.resetForm();
    };

    const handleSelectBox = (name: string, value: any) => {
        setFieldValue(name, value);
    };

    return (
        <BillingContext.Provider
            value={{
                ResetForm,
                initialValues,
                values,
                handleChange,
                handleSelectBox,
                errors,
                touched,
                setFieldValue,
                handleBlur,
                handleSubmit,
            }}
        >
            {children}
        </BillingContext.Provider>
    );
};

export default BillinEntryContext;
